module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	var _Promise = fox.RSVP.Promise;
	
	fox.registerWidget('EmptyPlaceholder', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'empty_placeholder',
				widgets: {
					content: {
						widget: 'Widget',
						'embed.container': '#placeholder-content-container',
						template: 'def_placeholder_content',
						autoRender: true
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this._readyToEmbed = false;
			this.callParent('running', arguments);
		},

		deactivate: function () {
			if (this.isEmbedded()) {
				this._readyToEmbed = true;

				this.wait('addedToDom').then(function () {
					this._readyToEmbed = false;
				}.bind(this));
			}

			return this.callParent('deactivate', arguments);
		},

		showIfEmpty: function (promise) {
			if (!(promise instanceof _Promise)) promise = _Promise.resolve(!!promise);

			return promise.then(function (isEmpty) {
				var promise = this.wait('addedToDom');

				if (isEmpty) {
					this._readyToEmbed = true;
					this.render();
				} else if (!isEmpty && this.isEmbedded()) {
					this.removeFromDom();
				}

				return promise;
			}.bind(this)).then(function (resp) {
				this._readyToEmbed = false;

				return resp;
			}.bind(this));
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/emptyPlaceholder.js
// module id = 309
// module chunks = 2